import {
    PasswordAuthenticationInfo
} from '@cnri/doip-client';
import * as DoipModule from '@cnri/doip-client';
import { Notifications } from './ToastrNotifications.js';
import { TokenUsingDoipClient } from './TokenUsingDoipClient.js';


export class CordraUiSupport {

    private readonly doipClient: TokenUsingDoipClient;
    private readonly notifications: Notifications;
    private readonly displaySignInFunction: () => void;
    Doip = DoipModule;

    constructor(doipClient: TokenUsingDoipClient, notifications: Notifications, displaySignInFunction: () => void) {
        this.doipClient = doipClient;
        this.notifications = notifications;
        this.displaySignInFunction = displaySignInFunction;
    }

    getDoipClient(): TokenUsingDoipClient {
        return this.doipClient;
    }

    getNotifications(): Notifications {
        return this.notifications;
    }

    displaySignInForm(): void {
        this.displaySignInFunction();
    }

    getPasswordAuthenticationInfoClass(): typeof PasswordAuthenticationInfo {
        return PasswordAuthenticationInfo;
    }

}
